module.exports = __webpack_public_path__ + "static/lions-roar-83d03e9b7fa7e4ecc49ed6ed1e7c0c8d.png";